<template>
  <v-content>
    <v-container>
      <v-layout justify-center>
        <v-flex xs10 md8 lg6>
          <img src="@/assets/titles/title.svg" />
          <router-link to="et" class="block">
            <img src="@/assets/titles/et.svg" />
          </router-link>
          <router-link to="ru" class="block">
            <img src="@/assets/titles/ru.svg" />
          </router-link>
          <router-link to="en" class="block">
            <img src="@/assets/titles/en.svg" />
          </router-link>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>

export default {

  name: 'Home',

};
</script>
